import React from 'react';
import EsgTable from './EsgFeedTable';
import styles from './EsgFeed.module.scss';
import EsgFeedSort from './EsgFeedSort';

export const EsgFeedMiddle = () => (
  <div className={styles.container}>
    <div className={styles.headerRow}>
      <div className={styles.headerContent}>
        <div className={styles.headerTitle}>ESG Feed</div>
        <div className={styles.headerSubtitle}>Global CapitalIQ</div>
        <div className={styles.headerYear}>FY 2021</div>
      </div>
      <div className={styles.SortRow}>
        {/* <div className={styles.Search}>
          <input placeholder="Search..." type="text" className={styles.SearchInput} />
          <img className={styles.SearchImg} src="/images/navbar/search.png" alt="search" />
        </div> */}
        {/* <div className={styles.Sort}>
          <EsgFeedSort />
        </div> */}
      </div>
    </div>
    <div className={styles.tableConatiner}>
      <EsgTable />
    </div>
  </div>
);
